<!-- Content holder is card with flexible styling it can be reusable at the same parent -->
<div class="content-holder" *transloco="let t">
  <div class="header align-items-center">
    <p class="title">
      @if (detailsForm == 'email') {
        <span>{{t('authentication.change_email')}}</span>
      }
      @if (detailsForm == 'password') {
        <span>{{t('authentication.change_password')}}</span>
      }
    </p>
    @if (detailsForm == 'email' && user()) {
      <div class="subtitle">{{user().email}}</div>
    }
    @if (detailsForm == 'password') {
      <div class="subtitle">{{t('authentication.make_new_password')}}</div>
    }
  </div>
  <!--
  Use bootstrap grid system for content placment inside of body element
  -->
  <div class="row body">
    <!-- Place your contet here -->

    @if (detailsForm == 'email') {
      <div class="mt-4">
        <multisite-email-input-form
          [labelTextTranslationKey]="'authentication.new_email'"
          (emailSubmitted)="doChangeEmail($event)"
          [errorTranslationKey]="error"
          [loading]="loading" ngClass="w-100">
        </multisite-email-input-form>
        @if (!loading) {
          <div class="my-2">
            @if (error && detailsForm !== 'email') {
              <alert [type]="'warning'" [dismissible]="true">
                <span [innerHTML]="t(error)"></span>
              </alert>
            }
            @if (user()?.email_pending) {
              <alert [type]="'success'" [dismissible]="true">
                <p >{{ t('authentication.check_your_email_or_spam', {email:user()?.email_pending}) }}</p>
              </alert>
            }
          </div>
        }
      </div>
    }
    @if (detailsForm == 'password') {
      <div class="mt-4">
        <form [formGroup]="changePasswordForm" role="form">
          <!-- Old Password* -->
          <div class="input-self">
            <label for="oldPassword" class="form-label">
              {{ t('authentication.old_password') }}<span class="required-sign">*</span>
            </label>
            <div
              class="input-group mb-3"
              [class.ng-invalid]="showOldPasswordError"
              [class.ng-valid]="isOldPasswordValid"
              >
              <span class="input-group-text text-primary-light">
                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
              </span>
              <input
                class="form-control input-lg"
                type="password"
                id="oldPassword"
                formControlName="oldPassword"
                />
              <div id="oldPasswordHelpBlock" class="form-input-feedback">
                <!-- TODO this element disappears when there input is valid -->
                <a (click)="oldPasswordForgotten = !oldPasswordForgotten" class="text-link text-small">{{t('authentication.forgot_old_password_question')}}</a>
              </div>
              @if (showOldPasswordError) {
                <div class="invalid-feedback">
                  {{ t(oldPasswordErrorKey) }}
                </div>
              }
            </div>
          </div>
          @if (oldPasswordForgotten) {
            <button class="btn btn-primary my-3" (click)="requestNewPasswordLink()" [disabled]="loading">
              <span>{{t('authentication.get_new_password')}}</span>
            </button>
          }
          @if (!oldPasswordForgotten) {
            <!-- Password* -->
            <div class="input-self">
              <label for="password" class="form-label">
                {{ t('authentication.new_password') }}<span class="required-sign">*</span>
              </label>
              <div
                class="input-group mb-3"
                [class.ng-invalid]="showPasswordError"
                [class.ng-valid]="isPasswordValid"
                >
                <span class="input-group-text text-primary-light">
                  <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                </span>
                <input
                  class="form-control input-lg"
                  type="password"
                  id="password"
                  formControlName="password"
                  />
                @if (showPasswordError) {
                  <div class="invalid-feedback">
                    {{ t(passwordErrorKey) }}
                  </div>
                }
              </div>
            </div>
            <!-- Repeat password* -->
            <div class="input-self">
              <label for="repeatPassword" class="form-label">
                {{ t('authentication.password_again') }}<span class="required-sign">*</span>
              </label>
              <div
                class="input-group mb-3"
                [class.ng-invalid]="showRepeatPasswordError"
                [class.ng-valid]="isRepeatPasswordValid"
                >
                <span class="input-group-text text-primary-light">
                  <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                </span>
                <input
                  class="form-control input-lg"
                  type="password"
                  id="repeatPassword"
                  formControlName="repeatPassword"
                  />
                @if (showRepeatPasswordError) {
                  <div class="invalid-feedback">
                    {{ t(repeatPasswordErrorKey) }}
                  </div>
                }
              </div>
            </div>
            @if (error && !loading) {
              <alert [type]="'warning'" [dismissible]="true">
                <span [innerHTML]="t(error)"></span>
              </alert>
            }
            <!-- Submit | Button -->
            <div class="input-self">
              <div class="input-group my-3">
                @if (!loading) {
                  <button
                    class="btn btn-lg btn-primary w-100"
                    [disabled]="!canSubmit"
                    (click)="changePassword()"
                    >
                    {{ t('common.confirm') }}
                  </button>
                }
                @if (loading) {
                  <multisite-loader-globe-animation-detail
                    [width]="100"
                    [height]="100"
                    >
                  </multisite-loader-globe-animation-detail>
                }
              </div>
            </div>
          }
        </form>
        @if (showPasswordSuccessAlert) {
          <alert [type]="'success'" [dismissOnTimeout]="9000" class="my-3">
            <strong>{{ t('common.success')! }}</strong><br>
            @if (showCheckInboxText) {
              <p>{{ t('authentication.check_your_email',{ email: user()?.email }) }}</p>
            }
            <p >{{ t(passwordSuccessTranslationKey) }}</p>
          </alert>
        }
      </div>
    }
    @if (loading && detailsForm !== 'email') {
      <multisite-loader-globe-animation-detail [width]="80" [height]="80" class="my-3"></multisite-loader-globe-animation-detail>
    }



  </div>
  <!--
  Footer: justify-content-start, justify-content-center or justify-content-end
  -->
  <!-- <div class="footer justify-content-end">
  <button class="btn-sm btn-primary primary-dark" *ngIf="detailsForm == 'password'">Save changes</button>
</div> -->
</div>
